export const TOAST_LIFETIME = 4000;
export const FULL_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const SHORT_DATE_FORMAT = 'yyyy-MM-dd';
